import * as React from "react";
import {cx} from "emotion";

import "./money-input.scss";

import {cs}                         from "@Common/react/chain-services";
import {PositiveNumberInputBinding} from "@Common/react/positive-number-input-binding";
import {UseState}                   from "@Common/react/use-state";

export const MoneyInput = ({state, className=undefined, style=undefined, ...params}) => cs(
    ["focused", (_, next) => UseState({next})],
    ["numberBinding", (_, next) => PositiveNumberInputBinding({state, next})],
    ["initValue", (_, next) => UseState({
        initValue: params.initValue,
        next,
    })],
    ({focused, numberBinding, initValue}) => (
        <div className={cx("money-input money-input-56r", {focused: focused.value, hasDollarSign: focused.value || state.value != null})}>
            <label data-amount={params.action === 'add' ? (
                `New Balance: $${Math.abs(Math.round((initValue.value + state.value)*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
            ) : params.action === 'sub' ? (
                (Math.round((initValue.value - state.value)*100)/100) < 0 ? (
                    `New Balance: $0.00` 
                ) : (
                    `New Balance: $${Math.abs(Math.round((initValue.value - state.value)*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                )
            ) : initValue.value <= state.value ? (
                `Adding $${Math.abs(Math.round((initValue.value - state.value)*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
            ) : (
                `Subtracting $${Math.abs(Math.round((initValue.value - state.value)*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
            )}
                xd-qa-type="label"
                xd-qa-name={params.action === 'add' || params.action === 'sub' ? (
                    "New Balance"
                ) : initValue.value <= state.value ? (
                    "Adding"
                ) : (
                    "Subtracting"
                )}
            >
                <input {...{
                    ...params,
                    className: cx(className),
                    style: {
                        ...style?.height && {
                            height: style.height,
                        },
                    },
                    ...!focused.value ? {
                        value: ((state.value == null || state.value == 0) && params.action !== 'set') ? "" : (Math.round(state.value*100)/100).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                        onChange: () => {},
                    } : (
                        numberBinding
                    ),
                    onFocus: (e) => {
                        focused.onChange(true);
                        e.target.select();
                    },
                    onBlur: () => {
                        focused.onChange(false);
                        numberBinding.onBlur();
                    },
                }}
                    xd-qa-type="textbox"
                    xd-qa-name="Money Input"
                />
            </label>
        </div>
    )
);
